module.exports = __webpack_public_path__ + "img/qr_code.40e1b1da.png";